import { useEffect } from "react";

import useUserContext from "./useUserContext";

export default function usePageTitle(pageTitle: string) {
    const [userContext] = useUserContext();

    useEffect(() => {
        setTimeout(() => {
            // environment is empty until the user context loads; ""[0] is undefined and threw here.
            const environment = userContext.environment ?? "";
            const env =
                environment === "Prod" || environment === ""
                    ? ""
                    : environment[0].toUpperCase() + environment.slice(1);
            document.title = pageTitle
                ? `${env} - ${pageTitle}`
                : `${env} - Dimension Portal`;
        }, 25);
        
    }, [pageTitle, userContext.environment]);
}
